import s from './project-manual.module.scss';
import { TabContent } from '../../organisms/tab-contnet';

export const ProjectManual = () => (
	<div className={s.manual}>
		<TabContent />
	</div>
);
